<template>
  <b v-if="count > 0" class="ui-count-badge" :class="`is-${size}`">{{ displayCount }}</b>
</template>

<script>
export default {
  name: 'UiCountBadge',
  props: {
    count: { type: Number, default: 0 },
    max: { type: Number, default: 99 },
    size: {
      type: String,
      default: 'normal',
      validator: value => ['normal', 'large'].includes(value)
    }
  },
  computed: {
    displayCount () {
      return this.count > this.max ? `${this.max}+` : this.count
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-count-badge {
  min-width: 15px;
  height: 15px;
  display: inline-block;
  padding: 0 3px;
  color: var(--ui-color-white);
  border: 1px solid var(--ui-bg-control);
  border-radius: 8px;
  background: var(--ui-color-danger);
  box-sizing: border-box;
  font-size: 9px;
  font-weight: 700;
  line-height: 13px;
  letter-spacing: 0;
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 0 7px rgba(var(--ui-color-danger-rgb), .45);
}

.ui-count-badge.is-large {
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 9px;
  font-size: 11px;
  line-height: 16px;
}
</style>
